var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomBlock1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 200,
    viewBox: "0 0 400 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 200,
    fill: "#F6F6FB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2013_1970)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 112,
    transform: "translate(0 44)",
    fill: "#B5C3E5"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 44,
    width: 400,
    height: 112,
    fill: "#F6F6FB"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -152.735,
    y1: 49.6568,
    x2: 164.049,
    y2: -267.127,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -145.664,
    y1: 56.7279,
    x2: 171.12,
    y2: -260.056,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -138.593,
    y1: 63.799,
    x2: 178.191,
    y2: -252.985,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -131.522,
    y1: 70.87,
    x2: 185.262,
    y2: -245.914,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -124.451,
    y1: 77.9411,
    x2: 192.333,
    y2: -238.843,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -117.38,
    y1: 85.0122,
    x2: 199.404,
    y2: -231.772,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -110.309,
    y1: 92.0833,
    x2: 206.475,
    y2: -224.701,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -103.238,
    y1: 99.1543,
    x2: 213.546,
    y2: -217.63,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -96.1664,
    y1: 106.225,
    x2: 220.617,
    y2: -210.558,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -89.0954,
    y1: 113.296,
    x2: 227.688,
    y2: -203.487,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -82.0243,
    y1: 120.368,
    x2: 234.76,
    y2: -196.416,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -74.9533,
    y1: 127.439,
    x2: 241.831,
    y2: -189.345,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -67.8822,
    y1: 134.51,
    x2: 248.902,
    y2: -182.274,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -60.8112,
    y1: 141.581,
    x2: 255.973,
    y2: -175.203,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -53.7401,
    y1: 148.652,
    x2: 263.044,
    y2: -168.132,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -46.6691,
    y1: 155.723,
    x2: 270.115,
    y2: -161.061,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -39.5981,
    y1: 162.794,
    x2: 277.186,
    y2: -153.99,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -32.527,
    y1: 169.865,
    x2: 284.257,
    y2: -146.919,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -25.456,
    y1: 176.936,
    x2: 291.328,
    y2: -139.848,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -18.3847,
    y1: 184.007,
    x2: 298.399,
    y2: -132.777,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -11.3136,
    y1: 191.078,
    x2: 305.47,
    y2: -125.706,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4.24258,
    y1: 198.149,
    x2: 312.541,
    y2: -118.635,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.82846,
    y1: 205.22,
    x2: 319.612,
    y2: -111.564,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.89951,
    y1: 212.291,
    x2: 326.683,
    y2: -104.492,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.9706,
    y1: 219.362,
    x2: 333.754,
    y2: -97.4214,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.0416,
    y1: 226.434,
    x2: 340.825,
    y2: -90.3503,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 31.1126,
    y1: 233.505,
    x2: 347.897,
    y2: -83.2793,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38.1837,
    y1: 240.576,
    x2: 354.968,
    y2: -76.2082,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.2547,
    y1: 247.647,
    x2: 362.039,
    y2: -69.1371,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.326,
    y1: 254.718,
    x2: 369.11,
    y2: -62.0661,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 59.3971,
    y1: 261.789,
    x2: 376.181,
    y2: -54.9949,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66.4681,
    y1: 268.86,
    x2: 383.252,
    y2: -47.9239,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.5392,
    y1: 275.931,
    x2: 390.323,
    y2: -40.8529,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.6102,
    y1: 283.002,
    x2: 397.394,
    y2: -33.7818,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 87.6812,
    y1: 290.073,
    x2: 404.465,
    y2: -26.7107,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 94.7523,
    y1: 297.144,
    x2: 411.536,
    y2: -19.6397,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 101.823,
    y1: 304.215,
    x2: 418.607,
    y2: -12.5686,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.894,
    y1: 311.286,
    x2: 425.678,
    y2: -5.49751,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 115.965,
    y1: 318.357,
    x2: 432.749,
    y2: 1.57353,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 123.036,
    y1: 325.428,
    x2: 439.82,
    y2: 8.64464,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130.108,
    y1: 332.5,
    x2: 446.892,
    y2: 15.7157,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 137.179,
    y1: 339.571,
    x2: 453.963,
    y2: 22.7868,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144.25,
    y1: 346.642,
    x2: 461.034,
    y2: 29.8578,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 151.321,
    y1: 353.713,
    x2: 468.105,
    y2: 36.9289,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 158.392,
    y1: 360.784,
    x2: 475.176,
    y2: 44,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 165.463,
    y1: 367.855,
    x2: 482.247,
    y2: 51.071,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 172.534,
    y1: 374.926,
    x2: 489.318,
    y2: 58.1421,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 179.605,
    y1: 381.997,
    x2: 496.389,
    y2: 65.2132,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 186.676,
    y1: 389.068,
    x2: 503.46,
    y2: 72.2842,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 193.747,
    y1: 396.139,
    x2: 510.531,
    y2: 79.3553,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200.818,
    y1: 403.21,
    x2: 517.602,
    y2: 86.4264,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 207.889,
    y1: 410.281,
    x2: 524.673,
    y2: 93.4974,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 214.961,
    y1: 417.352,
    x2: 531.744,
    y2: 100.569,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 222.032,
    y1: 424.423,
    x2: 538.815,
    y2: 107.64,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.103,
    y1: 431.494,
    x2: 545.886,
    y2: 114.711,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 236.174,
    y1: 438.566,
    x2: 552.958,
    y2: 121.782,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 243.245,
    y1: 445.637,
    x2: 560.029,
    y2: 128.853,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 250.316,
    y1: 452.708,
    x2: 567.1,
    y2: 135.924,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 257.387,
    y1: 459.779,
    x2: 574.171,
    y2: 142.995,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 264.458,
    y1: 466.85,
    x2: 581.242,
    y2: 150.066,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 271.529,
    y1: 473.921,
    x2: 588.313,
    y2: 157.137,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.669 112.389C115.895 112.389 114.24 112.097 112.703 111.513C111.189 110.907 109.858 110.063 108.711 108.981C107.564 107.9 106.666 106.634 106.017 105.184C105.39 103.713 105.076 102.122 105.076 100.413C105.076 98.6818 105.39 97.0914 106.017 95.6416C106.666 94.1919 107.553 92.9368 108.679 91.8766C109.825 90.8163 111.156 89.9941 112.671 89.4098C114.186 88.804 115.83 88.501 117.604 88.501C119.4 88.501 121.045 88.7823 122.538 89.3449C124.031 89.9075 125.329 90.6865 126.433 91.6818L122.116 96.0311C121.597 95.4685 120.958 95.0249 120.201 94.7004C119.465 94.3758 118.6 94.2135 117.604 94.2135C116.739 94.2135 115.938 94.3541 115.203 94.6354C114.488 94.9167 113.872 95.3279 113.352 95.8688C112.833 96.4098 112.422 97.0697 112.119 97.8487C111.838 98.606 111.697 99.4607 111.697 100.413C111.697 101.387 111.838 102.263 112.119 103.042C112.422 103.799 112.833 104.448 113.352 104.989C113.872 105.53 114.488 105.952 115.203 106.255C115.938 106.536 116.739 106.677 117.604 106.677C118.578 106.677 119.444 106.526 120.201 106.223C120.98 105.92 121.651 105.476 122.213 104.892L126.563 109.241C125.416 110.237 124.128 111.015 122.7 111.578C121.272 112.119 119.595 112.389 117.669 112.389Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.815 112.389C137.781 112.389 136.007 111.978 134.492 111.156C132.978 110.312 131.798 109.155 130.954 107.683C130.111 106.212 129.689 104.524 129.689 102.62V88.8905H136.18V103.204C136.18 103.94 136.342 104.567 136.667 105.087C136.991 105.606 137.424 106.006 137.965 106.288C138.528 106.547 139.144 106.677 139.815 106.677C140.508 106.677 141.113 106.547 141.633 106.288C142.174 106.006 142.596 105.617 142.899 105.119C143.202 104.6 143.353 103.972 143.353 103.237V88.8905H149.877V102.652C149.877 104.557 149.455 106.244 148.611 107.716C147.789 109.165 146.62 110.312 145.106 111.156C143.613 111.978 141.849 112.389 139.815 112.389Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.79 112.389C159.821 112.389 158.101 112.108 156.63 111.546C155.18 110.961 153.838 110.042 152.605 108.787L156.662 104.73C157.506 105.53 158.393 106.147 159.324 106.58C160.254 106.991 161.25 107.196 162.31 107.196C163.197 107.196 163.868 107.067 164.322 106.807C164.777 106.526 165.004 106.147 165.004 105.671C165.004 105.195 164.809 104.805 164.419 104.502C164.03 104.178 163.511 103.897 162.862 103.659C162.234 103.399 161.531 103.139 160.752 102.88C159.995 102.62 159.237 102.306 158.48 101.938C157.723 101.57 157.019 101.127 156.37 100.608C155.743 100.067 155.234 99.4066 154.845 98.6277C154.455 97.8271 154.26 96.8533 154.26 95.7065C154.26 94.2135 154.617 92.926 155.332 91.8441C156.046 90.7622 157.052 89.94 158.35 89.3774C159.648 88.7932 161.174 88.501 162.926 88.501C164.658 88.501 166.259 88.7823 167.73 89.3449C169.223 89.8859 170.457 90.6648 171.43 91.6818L167.341 95.739C166.627 95.0466 165.913 94.5381 165.198 94.2135C164.484 93.8673 163.705 93.6942 162.862 93.6942C162.191 93.6942 161.65 93.8024 161.239 94.0188C160.849 94.2351 160.654 94.5597 160.654 94.9925C160.654 95.4469 160.849 95.8255 161.239 96.1285C161.628 96.4098 162.137 96.6694 162.764 96.9074C163.413 97.1455 164.117 97.3943 164.874 97.654C165.653 97.9136 166.421 98.2274 167.178 98.5952C167.936 98.9414 168.628 99.3958 169.256 99.9584C169.905 100.499 170.424 101.181 170.814 102.003C171.203 102.825 171.398 103.821 171.398 104.989C171.398 107.348 170.554 109.176 168.866 110.475C167.2 111.751 164.841 112.389 161.79 112.389Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.191 112V88.8905H186.682V112H180.191ZM173.278 94.4082V88.8905H193.628V94.4082H173.278Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.872 112.454C206.055 112.454 204.378 112.151 202.841 111.546C201.327 110.94 199.996 110.096 198.849 109.014C197.724 107.932 196.848 106.655 196.22 105.184C195.593 103.713 195.279 102.122 195.279 100.413C195.279 98.6818 195.582 97.0914 196.188 95.6416C196.815 94.1919 197.692 92.926 198.817 91.8441C199.942 90.7622 201.262 89.9292 202.776 89.3449C204.313 88.7391 205.99 88.4361 207.807 88.4361C209.625 88.4361 211.291 88.7391 212.806 89.3449C214.342 89.9292 215.673 90.7622 216.798 91.8441C217.923 92.926 218.789 94.2027 219.395 95.6741C220.022 97.1238 220.336 98.7142 220.336 100.445C220.336 102.155 220.022 103.745 219.395 105.216C218.789 106.666 217.923 107.943 216.798 109.046C215.673 110.128 214.353 110.972 212.838 111.578C211.324 112.162 209.668 112.454 207.872 112.454ZM207.807 106.742C209.019 106.742 210.069 106.482 210.956 105.963C211.843 105.444 212.524 104.708 213 103.756C213.477 102.804 213.715 101.689 213.715 100.413C213.715 99.4607 213.574 98.606 213.293 97.8487C213.033 97.0697 212.643 96.4098 212.124 95.8688C211.605 95.3062 210.977 94.8843 210.242 94.603C209.528 94.3001 208.716 94.1486 207.807 94.1486C206.596 94.1486 205.546 94.4082 204.659 94.9276C203.772 95.4252 203.09 96.1501 202.614 97.1022C202.138 98.0326 201.9 99.1362 201.9 100.413C201.9 101.387 202.03 102.263 202.29 103.042C202.571 103.821 202.971 104.492 203.491 105.054C204.01 105.595 204.627 106.017 205.341 106.32C206.076 106.601 206.899 106.742 207.807 106.742Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.307 112V88.8905H229.014L237.615 101.484H235.57L244.139 88.8905H248.845V112H242.418V99.5365L243.36 99.7961L238.653 106.547H234.499L229.825 99.7961L230.734 99.5365V112H224.307Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.446 112L273.47 88.8905H278.534L274.477 112H269.446ZM260.066 105.736V101.516H279.345V105.736H260.066ZM261.818 112L265.875 88.8905H270.874L266.882 112H261.818ZM261.234 98.8873V94.7004H280.481V98.8873H261.234Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.382 112V88.8905H293.809V112H287.382ZM283.065 94.2135V88.8905H293.484V94.2135H283.065Z",
    fill: "#2C314F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2013_1970"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 112,
    fill: "white",
    transform: "translate(0 44)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomBlock1);
export default __webpack_public_path__ + "static/media/custom-block-1.f921eb4cc71ee87de4d3b2d64457fc0c.svg";
export { ForwardRef as ReactComponent };